import { Heading, HeadingProps } from '@chakra-ui/react'; // TODO: this should come from Typography.
import React from 'react';

import { useMultiStyleConfig } from '../../system/hooks';

import DisplayNames from './enums';

export type SideBarHeadingProps = HeadingProps;
const SideBarHeading = (props: SideBarHeadingProps): React.ReactElement => {
  const { sideBarHeading: themeStyles } = useMultiStyleConfig('SideBar', props);

  const computedProps: HeadingProps = {
    as: 'h2',
    ...(themeStyles as HeadingProps),
    ...props
  };

  return <Heading {...computedProps} />;
};

SideBarHeading.propTypes = {};
SideBarHeading.displayName = DisplayNames.SideBarHeading;

export default SideBarHeading;
